// extracted by mini-css-extract-plugin
module.exports = {"normal":"Tab_normal__2BqYb","active":"Tab_active__1hp6w Tab_normal__2BqYb"};